export const isDuplicateCalculationName = (
  calculations: any,
  name: string,
  session: any,
  selectedDs: any,
): boolean => {
  return (
    calculations.savedCalculations.some(
      (calc: any) => calc.name === name && calc.datasetId === selectedDs.id,
    ) && !session.uuid
  );
};
